<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n3">{{$t("scan-mobile-registrations")}}</h1>
        </v-flex>

        <v-flex xs12 class="mb-4">
          <v-layout row wrap>
          <v-btn v-if="!ScanMobileDisableButtons" class="ml-1 mr-1 mt-4" :to="{name: 'create-scan-mobile-registration', params: {id: null, pendingVehicles: pendingVehicles}}" color="primary">
            <v-icon left>add</v-icon>
            {{$t("New")}}
          </v-btn>
          <div>
            <v-btn class="ml-1 mt-4" @click="refreshData" :color="'primary'">
                        {{$t("Refresh")}}
            </v-btn>
            <v-flex xs12>
              <div class="ml-2 textsize-small" style="text-align: left">{{$t("Updated")}} {{timeSinceLastUpdate}}</div>
            </v-flex>
        </div>
          <v-flex d-flex class="textsize-large ml-1 mt-4" style="align-items:center; justify-content:center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis" >
                            <div class="text-center" :style="getColorStr()">
                              {{displayWeight}} kg
                            </div>
                          </v-flex>
          <v-flex shrink><v-select v-if="localZplPrint" class="ml-2" style="max-width:90px" hide-details="true" :items="printers" v-model="printerNo" label="Printer" @change="printerChanged" :item-text="item => item.no" :no-data-text="ct.NoDataAvailable"></v-select></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true"  style="max-width:170px" :items="VT25List" v-model="selectedVT25" @change="saveVT25(selectedVT25)" :label="$t('Weight Indicator')"></v-select></v-flex>
          <v-flex shrink><v-select class="ml-2" hide-details="true"  style="max-width:170px" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select></v-flex>
         </v-layout>
        </v-flex>

        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No unfinished registrations found")}}</div>
          <div v-else v-for="smReg in orderedRegistrations" :key="smReg.id">
            <v-card raised class="mb-4" v-if="smReg.FinishedBy == null && !smReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{smReg.Registration.VehicleNo}} - {{smReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.ArticleNo}} - {{smReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.CarrierNo}} - {{smReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.AgreementNo}} - {{smReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.DeliveryNo}} - {{smReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("1. weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getGrossWeightStr(smReg)}}</v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Terminal")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.TerminalId}} </v-flex>
                  </v-layout> -->
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(smReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.PlantNo}} - {{smReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 md4>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("1. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{smReg.Registration.WeightFirst}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("2. weight")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right" :style="getColorStr()">{{displayWeight}} kg</v-flex>
                    </v-layout>
                    <v-layout row wrap class="textsize-large mb-n4" style="padding: 2px 2px 2px 14px">
                      <v-flex d-flex xs4 class="font-weight-bold">{{$t("Netto")}}:</v-flex>
                      <v-flex d-flex xs4 class="font-weight-bold" style="justify-content:right">{{Math.abs(smReg.Registration.WeightFirst-displayWeight)}} kg</v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="smReg.FinishedBy == null && !smReg.Registration.Completed">
                  <v-flex xs12 text-left>
                   <v-btn class="mr-1 mb-1 ml-2" @click.prevent="preCancel(smReg)" :color="'error'">
                      {{$t("Cancel")}}
                    </v-btn>
                    <v-btn v-if="showGotoDeliveryInspection(smReg)" class="mr-1 mb-1"  @click="gotoDeliveryInspection(smReg)" color="success">{{$t("Go to Delivery Inspection")}}</v-btn>
                  </v-flex>
                  <v-flex xs12 text-right>
                    <v-btn class="mr-1 mb-1" @click.prevent="preFinish(smReg)" color="success" :disabled="validate(smReg)">
                      {{$t("2. Registration")}}
                    </v-btn>
                    <v-btn v-if="!ScanMobileDisableButtons" class="mr-1 mb-1" :to="{name: 'edit-scan-mobile-registration', params: {id: smReg.Id, pendingVehicles: []}}" color="primary">
                      {{$t("Edit")}}
                    </v-btn>
                    <v-btn v-if="showEnterButton" class="mr-2 mb-1" :to="{name: 'add-scan-mobile-weight', params: {id: smReg.Id}}" :color="'primary'">
                      {{$t("Enter")}}{{smReg.Comment ? ' (' + smReg.Comment + ')' : ''}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <h2 class="mb-4 mt-4">{{$t("Recent Registrations")}}</h2>
        </v-flex>

        <div v-if="loading"></div>
        <v-flex xs12 v-else>
          <div v-if="registrations != null && registrations.length == 0" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
          <div v-else v-for="smReg in orderedRegistrationsReverse" :key="smReg.id">
            <v-card raised class="mb-4" v-if="smReg.FinishedBy != null || smReg.Registration.Completed">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                    <v-flex d-flex xs8 class="font-weight-bold" >{{smReg.Registration.VehicleNo}} - {{smReg.Registration.VehicleLicensePlateNo}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.ArticleNo}} - {{smReg.Registration.ArticleName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.CarrierNo}} - {{smReg.Registration.CarrierName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.AgreementNo}} - {{smReg.Registration.AgreementName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.DeliveryNo}} - {{smReg.Registration.DeliveryName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo1}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.RequisitionNo2}}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.ScanXRegNo}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("1. weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{getGrossWeightStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("2. weight")}}:</v-flex>
                    <v-flex d-flex xs8>{{get2WeightStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("WeightNet")}}:</v-flex>
                    <v-flex d-flex xs8>{{getNetWeightStr(smReg)}}</v-flex>
                  </v-layout>
                  <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                    <v-flex d-flex xs8>{{getDate(smReg.Registration.DateFirst)}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                    <v-flex d-flex xs8 style="padding-right: 6px">{{smReg.Registration.PlantNo}} - {{smReg.Registration.PlantName}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Facility}}</v-flex>
                  </v-layout>
                  <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                    <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                    <v-flex d-flex xs8>{{smReg.Registration.Comment1}}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-card-actions style="padding: 0px 0px 0px 0px" v-if="smReg.FinishedBy != null || smReg.Registration.Completed">
                  <v-flex v-if="showTextField(smReg)" xs6>
                    <div class="red--text" style="padding: 0px 0px 0px 10px">{{getMessage(smReg)}}</div>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <v-btn v-if="showGotoDeliveryInspection(smReg)" class="ml-2" @click="gotoDeliveryInspection(smReg)" color="success">{{$t("Go to Delivery Inspection")}}</v-btn>
                  </v-flex>
                  <v-flex xs12 text-right>
                    <v-btn class="mr-1 mb-1" @click="preRecall(smReg)" color="primary" :disabled="!smReg.Registration.Completed || smReg.Registration.ScanXRegNo != 0">
                      {{$t("Recall")}}
                    </v-btn>
                    <v-btn v-if="localZplPrint" class="mr-1 mb-1" @click="printRegistrationZPL(smReg.Id)" color="primary" :disabled="!smReg.Registration.Completed || smReg.Registration.ScanXRegNo == 0 || !printerIp">
                      {{$t("Print Mobile")}}
                    </v-btn>
                    <v-btn class="mr-1 mb-1" @click="printRegistration(smReg.Id)" color="primary" :disabled="!smReg.Registration.Completed || smReg.Registration.ScanXRegNo == 0">
                      {{$t("Print")}}
                    </v-btn>
                  </v-flex>
              </v-card-actions>
            </v-card>
          </div>

        </v-flex>
      </v-layout>

        <v-dialog
          v-model="confirmZeroKgDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("NoWeightAdded")}}</v-card-title>
            <v-card-text>{{$t("NoWeightDescription")}}</v-card-text>
            <v-card-text>{{$t("Tare")}} (kg): {{TareWeight}}</v-card-text>
            <v-card-text>{{$t("WeightNet")}}: {{WeightNet}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="confirmZeroKgDialog = false">{{$t("Ok")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="areYouSureCancelDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Cancel")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to cancel this registration?")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureCancelDialog = false; cancelRegistration(smReg.Id)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureCancelDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
          v-model="areYouSureFinishDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Finish")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to finish 2. Registration.")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureFinishDialog = false; capture(smReg)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureFinishDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog
          v-model="confirmRecallDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("Recall")}}</v-card-title>
            <v-card-text>{{$t("Are you sure you wish to recall registration")}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn ref="yesButton" color="success" @click="confirmRecallDialog = false; unFinishRegistration(smReg.Id)">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="confirmRecallDialog = false" autofocus>{{$t("No")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="waitForCaptureDialog" max-width="350">
          <v-card>
            <v-card-title class="headline">{{$t("Image Capture")}}</v-card-title>
            <v-card-text>{{$t("Please wait, while system captures images…")}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <!--<v-btn ref="yesButton" color="success" @click="waitForCaptureDialog = false;">{{$t("Yes")}}</v-btn>-->
            </v-card-actions>
          </v-card>
        </v-dialog>

   </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import filters from '@/core/mixins/common-filters'
import * as DateUtil from '@/core/date'
import * as ScanMobile from '@/modules/scan-mobile/scan-mobile'
import * as Archive from '@/core/archive'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import { UserDetail } from '@/core/userDetail'
import { black, red } from 'color-name'
import ct from '@/core/mixins/common-translations'
import _ from 'lodash' // clone

export default {
  mixins: [ct, filters],
  name: 'registrations',
  data () {
    return {
      loading: true,
      registrations: null,
      loadRegistrationsIntervalId: null,
      timedOutActionsIntervalId: null,
      facilityNo: null,
      facilities: [],
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      plantName: null,
      plants: [],
      ScanMobileDisableButtons: false,
      hiddenFields: [],
      pendingVehicles: [],
      confirmZeroKgDialog: false,
      WeightNet: 0,
      TareWeight: 0,
      isStable: false,
      selectedVT25: null,
      VT25List: [],
      displayWeight: '',
      areYouSureCancelDialog: false,
      areYouSureFinishDialog: false,
      confirmRecallDialog: false,
      showCancelDialog: false,
      showFinishDialog: false,
      showEnterButton: false,
      showRecallDialog: true,
      waitForCaptureDialog: false,
      weigthColor: red,
      camDelayEnabled: false,
      camDelay: 0,
      showGotoDeliveryInspectionBtn: false,
      localPrint: false,
      localZplPrint: false,
      printTitle: '',
      manualIndicator: false,
      regId: null,
      redirectToInspection: 'inspection',
      lastUpdatedRegistrationData: null,
      validDate: false,
      comitReg: null,
      cancelId: '00000000-0000-0000-0000-000000000000',
      finishId: '00000000-0000-0000-0000-000000000000',
      recalllId: '00000000-0000-0000-0000-000000000000',
      RegistrationType: { Registrations: '0', Deliveries: '1' },
      smReg: {
        id: '00000000-0000-0000-0000-000000000000',
        registrationId: '00000000-0000-0000-0000-000000000000',
        facilityNo: null,
        finishedDate: null,
        finishedBy: Security.user.name,
        comment: null,
        TareWeight: 0
      },
      zplPrinterIp: '',
      zplPrinterWidth: null,
      printerNo: '',
      printerIp: '',
      printers: []
    }
  },
  watch: {
  },
  methods: {
    printRegistration (regId) {
      if (this.localPrint) {
        var regs = this.registrations.filter(r => r.Id === regId)
        if (regs.length > 0) {
          this.$router.push({ name: 'print-scan-mobile', params: { id: regId, header: this.printTitle } })
        }
        return
      }
      ScanMobile.printRegistration(regId)
      this.$root.$message.showSuccess(this.$t('Confirmation printed'))
      this.keepLoadAlive()
    },
    printRegistrationZPL (regId) {
      var regs = this.registrations.filter(r => r.Id === regId)
      if (regs.length > 0) {
        this.$router.push({ name: 'print-scan-mobile-zpl', params: { id: regId, header: this.printTitle, zplPrinterIp: this.printerIp, zplPrinterWidth: this.zplPrinterWidth } })
      }
    },
    unFinishRegistration (regId) {
      if (regId === undefined) {
        regId = this.recalllId
        this.recalllId = '00000000-0000-0000-0000-000000000000'
      }

      var regs = this.registrations.filter(r => r.Id === regId)
      if (regs.length > 0) {
        ScanMobile.unfinishRegistration(regId)
      }
    },
    async loadScanMobileRegistrations () {
      const res = await ScanMobile.loadRegistrations({ Facility: this.facilityNo, RegistrationType: this.RegistrationType.Registrations })
      if (!res.failed) this.registrations = res.data
      // Filter registrations on plantName - if any
      // Load pending Vehicles for New button parameter
      this.pendingVehicles = this.registrations.filter(r => r.FinishedBy == null && !r.Registration.Completed).map(p => p.Registration.VehicleNo)
    },
    getColor () {
      if (this.isStable) {
        return black
      } else {
        return red
      }
    },
    getColorStr () {
      if (this.isStable || this.manualIndicator) {
        return 'color:black'
      } else {
        return 'color:red'
      }
    },
    showGotoDeliveryInspection (item) {
      return item.Registration.ScanXRegNo > 0 && this.showGotoDeliveryInspectionBtn
    },
    showTextField (item) {
      return item.Registration.ScanXRegNo === 0
    },
    async gotoDeliveryInspection (reg) {
      const res = await ScanMobile.loadDeliveryInspectionRegistration({ Facility: this.facilityNo, RegistrationNo: reg.Registration.ScanXRegNo })
      if (!res.failed && res.data && res.data.Id !== '00000000-0000-0000-0000-000000000000') {
        this.$router.push({ name: this.redirectToInspection, params: { id: res.data.Id } })
      } else {
        this.$root.$message.showError(this.$t('No Delivery Inspection found'))
      }
      this.keepLoadAlive()
    },
    validate (item) {
      return !this.isStable
    },
    preCancel (reg) {
      if (this.showCancelDialog) {
        this.cancelId = reg.Id
        this.areYouSureCancelDialog = true
      } else {
        this.cancelRegistration(reg.Id)
      }
      this.keepLoadAlive()
    },
    capture (reg) {
      if (this.camDelayEnabled) {
        if (!this.waitForCaptureDialog) {
          const res = ScanMobile.captureImageMsg({ facilityNo: this.facilityNo, corpName: Security.user.corporation, vehicleNo: this.comitReg.Registration.VehicleNo, indicator: this.selectedVT25 })
          if (!res.failed) {
            this.waitForCaptureDialog = true
            this.startCaptureTimer(this.comitReg.Id)
          }
        } else {
          this.finishRegistration(this.comitReg.Id)
        }
      } else {
        this.finishRegistration(this.comitReg.Id)
      }
    },
    preFinish (reg) {
      if (this.showFinishDialog) {
        this.comitReg = reg
        this.finishId = reg.Id
        this.areYouSureFinishDialog = true
      } else {
        if (this.camDelayEnabled) {
          if (!this.waitForCaptureDialog) {
            const res = ScanMobile.captureImageMsg({ facilityNo: this.facilityNo, corpName: Security.user.corporation, vehicleNo: reg.Registration.VehicleNo, indicator: this.selectedVT25 })
            if (!res.failed) {
              this.waitForCaptureDialog = true
              this.startCaptureTimer(reg.Id)
            }
          } else {
            this.finishRegistration(reg.Id)
          }
        } else {
          this.finishRegistration(reg.Id)
        }
      }
      this.keepLoadAlive()
    },
    preRecall (reg) {
      if (this.showRecallDialog) {
        this.recalllId = reg.Id
        this.confirmRecallDialog = true
      } else {
        this.unFinishRegistration(reg.Id)
      }
      this.keepLoadAlive()
    },
    startCaptureTimer (regId) {
      this.waitForCaptureDialog = true
      this.getRegTimer = setInterval(() => {
        if (this.waitForCaptureDialog) {
          this.waitForCaptureDialog = false
          clearInterval(this.getRegTimer)
          this.finishRegistration(regId)
        }
      }, this.camDelay * 1000)
    },
    getHeaderValue (item, header) {
      let result = ''
      if (!Object.prototype.hasOwnProperty.call(header, 'Source') || (header.Source === 'WeightRegistration' || header.Source == null)) {
        result = item.WeightRegistration[header.Field]
      } else {
        if (header.Source === 'ScanMobileRegistration') {
          result = item[header.Field]
        }
      }
      if (header.AsDate) result = DateUtil.getSmartDate(result)
      return result
    },
    getHeaderStyle (header) {
      let result = ''
      if (Object.prototype.hasOwnProperty.call(header, 'Style')) {
        result = header.Style
      }
      return result
    },
    stopWeightTimer () {
      if (this.getLiveWeightTimer) {
        this.checkkingIsAlive = false
        this.activeVT25 = false
        clearInterval(this.getLiveWeightTimer)
      }
      if (this.getRegTimer) clearInterval(this.getRegTimer)
    },
    async plantChanged () {
      if (this.plantName != null) LocalStorage.save('plantName', this.plantName)
      this.registrations = null
      this.loadScanMobileRegistrations()
    },
    async loadFacilityDetails () {
      const res = await ScanMobile.loadFacilityData({ facilityNo: this.facilityNo, corpName: Security.user.corporation })
      if (!res.failed) {
        if (res.data != null) {
          this.details = res.data.Details
          const printerDetail = this.details.find(o => o.Name === 'localPrinter')
          if (printerDetail !== undefined) {
            this.localPrint = (printerDetail.Value === 'true')
          }
          const printerZplDetail = this.details.find(o => o.Name === 'localZplPrinter')
          if (printerZplDetail !== undefined) {
            this.localZplPrint = (printerZplDetail.Value === 'true')
          }
          const printTitleDetail = this.details.find(o => o.Name === 'printTitle')
          if (printTitleDetail !== undefined) {
            this.printTitle = printTitleDetail.Value
          }
        }
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }

      if (this.facilityNo != null) LocalStorage.save('facilityNo', this.facilityNo)
      this.keepLoadAlive()
      if (this.facilityNo == null || this.facilityNo === '') {
        this.ScanMobileDisableButtons = true
      } else {
        this.ScanMobileDisableButtons = false
      }

      await this.loadFacilityDetails()
      // Re-Load Plants
      const plantsRes = await Archive.loadPlants(this.facilityNo)
      if (!plantsRes.failed) {
        // Let user select no plants (= show data from all allowed plants)
        if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
        this.plants = plantsRes.data.map(item => {
          return {
            text: item.Name,
            value: item.Name,
            item: item
          }
        })
      }
      // Set this.plantName
      if (this.plants.some(e => e.item.Name === this.plantName)) {
        // this.plantName is OK
      } else {
        this.plantName = null
        LocalStorage.remove('plantName')
      }

      this.registrations = null
      // Re-Load registrations
      this.loadScanMobileRegistrations()
      // re-Load Indicators
      const res = await ScanMobile.getCurrentWeightIds(this.facilityNo)
      this.manualIndicator = false
      if (!res.failed && res.data.length) {
        this.VT25List = res.data
        this.VT25List.unshift(['Manual']) // this.$t(['Manual']))
        if (this.selectedVT25 === 'Manual') { // this.$t('Manual')) {
          this.selectedVT25 = this.VT25List[0]
          this.manualIndicator = true
          this.displayWeight = 0
        }
      } else {
        this.VT25List = ['Manual']// this.$t(['Manual'])
        this.selectedVT25 = this.VT25List[0]
        this.manualIndicator = true
        this.displayWeight = 0
      }
    },
    async printerChanged () {
      this.printerIp = this.printers.find(p => p.no === this.printerNo).ip
      if (this.printerIp != null) LocalStorage.save('printerIp', this.printerIp)
      this.keepLoadAlive()
    },
    async updateUi () {
    },
    getDate (date) {
      return DateUtil.getSmartDate(date)
    },
    saveVT25 () {
      this.activeVT25 = this.selectedVT25
      this.manualIndicator = false
      if (this.selectedVT25[0] === 'Manual') { // this.$t('Manual')) {
        this.manualIndicator = true
        this.displayWeight = 0
      }
      LocalStorage.save('activeScanMobileIndicator', this.activeVT25)
      this.keepLoadAlive()
    },
    getCustomerStr (smReg) {
      if (smReg.Registration.CustomerNo && smReg.Registration.CustomerName) { return smReg.Registration.CustomerNo + ' - ' + smReg.Registration.CustomerName } else if (smReg.Registration.CustomerNo) { return smReg.Registration.CustomerNo } else if (smReg.Registration.CustomerName) { return smReg.Registration.CustomerName } else { return '' }
    },
    getGrossWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightFirst) + ' kg'
    },
    get2WeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightSecond) + ' kg'
    },
    getNetWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightNet) + ' kg'
    },
    getMessage (smReg) {
      if (smReg) {
        if (smReg.Registration.Cancelled) {
          return this.$t('Cancelled')
        } else if (!smReg.Registration.Completed) {
          if (!smReg.Registration.DateFirst) {
            return this.$t('No registration')
          } else {
            if (smReg.Registration.ScanXRegNo === 0) {
              return this.$t('Awaiting Weight ID from ScanX.NET')
            }
            return this.$t('Not checked out')
          }
        } else {
          if (smReg.Registration.ScanXRegNo === 0) {
            return this.$t('Awaiting Weight ID from ScanX.NET')
          }
          return ''
        }
      } else {
        return ''
      }
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    async cancelRegistration (id) {
    // Grab an update of the reg to get ScanXRegNo etc.
      if (id === undefined) {
        id = this.cancelId
        this.cancelId = '00000000-0000-0000-0000-000000000000'
      }
      const res1 = await ScanMobile.loadRegistration(id)
      if (!res1.failed) {
        this.smReg.Registration = res1.data.Registration
        this.smReg.id = id
        this.smReg.registrationId = this.smReg.Registration.Id
        this.smReg.facilityNo = this.facilityNo
        this.smReg.comment = this.smReg.Registration.Comment1
        this.smReg.Registration.Cancelled = true
      }
      this.submitting = true
      const res2 = await ScanMobile.saveRegistration({
        Id: this.smReg.id,
        RegistrationId: this.smReg.registrationId,
        Facility: this.smReg.facilityNo,
        DeletedDate: new Date(),
        DeletedBy: this.smReg.finishedBy,
        Comment: this.smReg.comment,
        Registration: this.smReg.Registration
      })
      this.submitting = false
      if (!res2.failed) {
        this.$root.$message.showError(this.$t('Cancelled'))
        // Re-Load registrations
        this.loadScanMobileRegistrations()
      }
    },
    refreshData () {
      this.loadScanMobileRegistrations()
      this.keepLoadAlive()
    },
    keepLoadAlive () {
      clearInterval(this.timedOutActionsIntervalId)
      clearInterval(this.loadRegistrationsIntervalId)
      this.startActionTimeOutTimer()
      this.startReloadRegistrationTimer()
    },
    startActionTimeOutTimer () {
    // if the system is idle for 6min we will stop auto updating
      this.timedOutActionsIntervalId = setInterval(async () => {
        // action time out
        clearInterval(this.loadRegistrationsIntervalId)
        clearInterval(this.timedOutActionsIntervalId)
      }, 900000)
    },
    startReloadRegistrationTimer () {
      // Update registration list every 5 seconds
      this.loadRegistrationsIntervalId = setInterval(async () => {
      // Re-Load registrations
        this.lastUpdatedRegistrationData = new Date()
        this.validDate = true
        this.loadScanMobileRegistrations()
      }, 5000)
    },
    async finishRegistration (id) {
      this.keepLoadAlive()
      if (id === undefined) {
        id = this.finishId
        this.finishId = '00000000-0000-0000-0000-000000000000'
      }
      const res0 = await ScanMobile.loadRegistration(id)
      if (!res0.failed) {
        this.smReg.Registration = res0.data.Registration
        this.smReg.id = id
        this.smReg.registrationId = this.smReg.Registration.Id
        this.smReg.facilityNo = this.facilityNo
        this.smReg.comment = this.smReg.Registration.Comment1

        // Grab an update of the reg to get ScanXRegNo etc.
        var res1 = await Archive.loadVehicle({ facilityNo: this.smReg.Registration.Facility, vehicleNo: this.smReg.Registration.VehicleNo })
        if (!res1.failed) {
          this.smReg.TareWeight = Math.round(res1.data.Details.find(o => o.Name === 'TareWeight')?.Value ?? 0)
          this.TareWeight = this.smReg.TareWeight
        }

        // Tare calulation for ScanMobile ONLY on Finish reg (Also in Weight.vue)
        this.smReg.Registration.DateFirst = new Date()
        this.smReg.Registration.WeightSecond = this.WeightNet
        this.smReg.Registration.DateSecond = new Date()
        this.smReg.Registration.WeightNet = Math.abs(this.smReg.Registration.WeightFirst - this.smReg.Registration.WeightSecond)
        this.WeightNet = this.smReg.Registration.WeightNet
        // validation check on positive WeightNet
        if (this.WeightNet <= 0) {
          this.confirmZeroKgDialog = true
          return
        }

        if (this.smReg.Registration.WeightSecond < 1) {
          this.$root.$message.showError(this.$t('Invalid weight. Please fix and retry') + ' (0 kg)')
          return
        }
      }
      this.submitting = true
      const res2 = await ScanMobile.saveRegistration({
        Id: this.smReg.id,
        RegistrationId: this.smReg.registrationId,
        Facility: this.smReg.facilityNo,
        FinishedDate: new Date(),
        FinishedBy: this.smReg.finishedBy,
        Comment: this.smReg.comment,
        Registration: this.smReg.Registration
      })
      this.submitting = false
      if (!res2.failed) {
        this.$root.$message.showSuccess(this.$t('Registration finished'))
        // Re-Load registrations
        this.loadScanMobileRegistrations()
      }
    }
  },
  computed: {
    orderedRegistrations: function () {
      var self = this // Need this to refence this.newestFirst inside compare function.
      var sortComparer = function (a, b) {
        // if a is less than b, return -1
        // if a is greater than b, return 1
        // if a is equal to b, return 0
        var aDate = new Date(a.CreatedDate)
        var bDate = new Date(b.CreatedDate)
        /* if(self.newestFirst)
          return bDate - aDate;
        else */
        return aDate - bDate
      }

      if (self.registrations) {
        return self.registrations.sort(sortComparer)
      } else {
        return []
      }
    },
    orderedRegistrationsReverse: function () {
      return this.orderedRegistrations.slice().reverse()
    },
    timeSinceLastUpdate: function () {
      if (!this.validDate) {
        return
      }
      const hours = this.lastUpdatedRegistrationData.getHours()
      const minutes = this.lastUpdatedRegistrationData.getMinutes()
      const sec = this.lastUpdatedRegistrationData.getSeconds()
      return '' + hours + ':' + minutes + ':' + sec
    }
  },
  beforeDestroy () {
    // Stop live poll VT25/WK60 getWeight
    this.stopWeightTimer()
    // Stop update of registration list
    clearInterval(this.loadRegistrationsIntervalId)
    clearInterval(this.timedOutActionsIntervalId)
  },
  async mounted () {
    this.startReloadRegistrationTimer()
    this.startActionTimeOutTimer()
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    const vt25 = LocalStorage.load('activeScanMobileIndicator')
    if (vt25) { this.activeVT25 = vt25 } else { LocalStorage.remove('activeScanMobileIndicator') }
    this.selectedVT25 = this.activeVT25
    if (this.selectedVT25 === 'Manual'/* this.$t('Manual') */) {
      this.VT25List = ['Manual'] // this.$t(['Manual'])
      this.manualIndicator = true
      this.displayWeight = 0
    }
    const res = await ScanMobile.getCurrentWeightIds(this.facilityNo)
    if (!res.failed && res.data.length) {
      this.VT25List = res.data
      this.VT25List.unshift(['Manual']) // this.$t(['Manual']))
      if (this.selectedVT25 === 'Manual') { // this.$t('Manual')) {
        this.selectedVT25 = this.VT25List[0]
        this.manualIndicator = true
        this.displayWeight = 0
      }
    } else {
      this.VT25List = ['Manual']// this.$t(['Manual'])
      this.selectedVT25 = this.VT25List[0]
      this.manualIndicator = true
      this.displayWeight = 0
    }

    // console.log('pip', this.selectedVT25)

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      this.ScanMobileDisableButtons = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Disable_Buttons')?.Data1 === 'true' ?? false
      const defaultHidden = 'RequisitionNo2,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      var noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showFinishDialog = true
      } else {
        this.showFinishDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Finish_Dialog')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Enter_Button')?.Data1 === undefined ?? false
      if (noValue) {
        this.showEnterButton = true
      } else {
        this.showEnterButton = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Enter_Button')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Cancel_Dialog')?.Data1 === undefined ?? false
      if (noValue) {
        this.showCancelDialog = true
      } else {
        this.showCancelDialog = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Show_Cancel_Dialog')?.Data1 === 'true' ?? false
      }
      noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
      if (noValue) {
        this.useFacilityDescription = false
      } else {
        this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
      }

      noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelayEnabled')?.Data1 === undefined ?? false
      if (noValue) {
        this.camDelayEnabled = false
      } else {
        this.camDelayEnabled = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelayEnabled')?.Data1 === 'true' ?? false
        noValue = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelay')?.Data1 === undefined ?? false
        if (noValue) {
          this.camDelay = 5
        } else {
          this.camDelay = Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_CamDelay')?.Data1
        }
      }
      const showGotoDeliveryInspectionDetail = await UserDetail.load(Security.user.id, 'ShowGotoDeliveryInspection')
      if (showGotoDeliveryInspectionDetail && showGotoDeliveryInspectionDetail.Value) this.showGotoDeliveryInspectionBtn = (showGotoDeliveryInspectionDetail.Value === 'true')

      const zplPrinterIpUserDetail = await UserDetail.load(Security.user.id, 'ZplPrinterIp')
      if (zplPrinterIpUserDetail && zplPrinterIpUserDetail.Value) {
        this.zplPrinterIp = zplPrinterIpUserDetail.Value
        if (this.zplPrinterIp) {
          const rawPrinterIps = this.zplPrinterIp.split(',')
          rawPrinterIps.forEach(ip => {
            this.printers.push({ no: ip.split('.')[3], ip: ip })
          })
        }
      }

      const zplPrinterWidthUserDetail = await UserDetail.load(Security.user.id, 'ZplPrinterWidth')
      if (zplPrinterWidthUserDetail && zplPrinterWidthUserDetail.Value) this.zplPrinterWidth = zplPrinterWidthUserDetail.Value
    }

    // Set old this.facilityNo from LocalStorage
    const storedPrinterIp = LocalStorage.load('printerIp')
    const printer = this.printers.find(p => p.ip === storedPrinterIp)
    if (printer && printer.no && printer.ip) {
      this.printerNo = printer.no
      this.printerIp = printer.ip
    } else {
      if (this.printers.length) {
        this.printerNo = this.printers[0].no
        this.printerIp = this.printers[0].ip
      } else LocalStorage.remove('printerIp')
    }
    // Load Facilities
    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
    }
    this.facilitiesDisplay = this.facilities
    if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
      var d = facilitiesResDescription.data
      if (!d.includes('')) d.unshift({ No: '', Description: '' })
      this.facilitiesDescription = d.map(item => {
        return {
          text: item.Description,
          value: item.Description,
          item: item
        }
      })

      this.facilitiesDisplay = this.facilitiesDescription
    }

    // Set old this.facilityNo from LocalStorage
    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
      this.facilityChanged()
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }

    // Load Plants
    const plantsRes = await Archive.loadPlants(this.facilityNo)
    if (!plantsRes.failed) {
      // Let user select no plants (= show data from all allowed plants)
      if (!plantsRes.data.includes('')) plantsRes.data.unshift({ No: '', Name: '' })
      this.plants = plantsRes.data.map(item => {
        return {
          text: item.Name,
          value: item.Name,
          item: item
        }
      })
    }
    // Set old this.plantName from LocalStorage
    const storedPlantName = LocalStorage.load('plantName')
    if (storedPlantName && this.plants.some(e => e.item.Name === storedPlantName)) this.plantName = storedPlantName
    else {
      this.plantName = null
      LocalStorage.remove('plantName')
    }

    // Load registration list first time
    this.loadScanMobileRegistrations()
    await this.loadFacilityDetails()
    this.loading = false
    // Start Timer with getWeight check to VT25 box (and communication to WK60)
    if (!this.manualIndicator) {
      this.getLiveWeightTimer = setInterval(async () => {
        // Only check IsAlive, if last check has ended
        // this.enableVT25WeightIntegration &&
        if (this.activeVT25 && !this.manualIndicator) {
          this.checkkingIsAlive = true
          const res = await ScanMobile.getWeight({ VT25Id: this.activeVT25, ResetWeight: 'False' })
          if (res.failed) {
            this.isAlive = false
            this.displayWeight = '�'
            this.firstErrorStatus = 'No connection'
            this.$root.$message.showError('GetWeight for "' + this.activeVT25 + '" errors')
          } else {
            this.displayWeight = res.data.WeightKg.toString()
            this.firstErrorStatus = res.data.ErrorMsg
            this.WeightNet = res.data.WeightKg
            this.isStable = res.data.IsStable
            if (!this.isStable) {
              this.weigthColor = red
            } else {
              this.weigthColor = black
            }
            if (res.data.IsStable) {
              this.WeightNet = res.data.WeightKg
            } else {
              this.WeightNet2 = res.data.WeightKg // + ' ~ '
            }
            if (this.firstErrorStatus !== '') {
              this.displayWeight = '-9999'
              this.isStable = false
            }
            if (!this.isAlive) this.isAlive = true
          }
          this.checkkingIsAlive = false
        }
      }, 2000)
    }
  }
}
</script>

<style>
@media print {
  .show-on-print {
    display: block !important;
  }
  body * {
    visibility: hidden;
  }
  #section-to-print, #section-to-print * {
    visibility: visible;
  }
  #section-to-print {
    position:absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  #table-to-print {
    position: absolute;
    left: 0;
    top: auto;
  }
  .v-main {
    padding: 0 !important;
  }
  .v-data-table td {
    font: 16px;
  }
  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
  }
}
</style>
